module.exports = __webpack_public_path__ + "img/nostart1.aedf2d2d.png";